$(function () {
  if (!customElements.get('about-global-vision')) {
    customElements.define(
      'about-global-vision',
      class aboutGlobalVision extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
          this.initCountUp();
        }

        init() {
          let flagWidth = 80;
          let flagHeight = 80;
          let $mapMainDom = $(this).find('.map_main');
          let $mapDom = $mapMainDom.find('svg');
          let countryList = $mapMainDom.data('countryIds')?.split(',');

          if (countryList?.length > 0) {
            countryList = [...new Set(countryList)];
            countryList.forEach((item) => {
              let $pathDom = $mapDom.find(`#${item}`);
              if ($pathDom.length) {
                let box = $pathDom[0].getBBox();
                let flagX = box.x + box.width / 2 - flagWidth / 2;
                let flagY = box.y + box.height / 2 - flagHeight / 2;
                let $flagDoms = $mapMainDom.find(`.flag.${item}`);

                $flagDoms.each((index, flagDom) => {
                  let $flagDom = $(flagDom);
                  if (index === 0) {
                    $flagDom.css({
                      left: `${flagX}px`,
                      top: `${flagY}px`,
                    });
                  } else {
                    $flagDom.hide();
                  }
                });
              }
            });
          }
        }

        initCountUp() {
          const $numberDomList = $(this).find('.count');

          if ($numberDomList.length) {
            $numberDomList.each((_, item) => {
              const $item = $(item);
              const number = Number($item.data('number'));

              new countUp.CountUp($item[0], number, {
                enableScrollSpy: true,
                scrollSpyOnce: true,
                scrollSpyDelay: 600,
                formattingFn: this._formatNumber,
              });
            });
          }
        }

        _formatNumber(value) {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'K';
          } else {
            return value.toString();
          }
        }
      }
    );
  }
});
